import moment from 'moment';

export function formatDate(date: string | number | Date, formating = 'DD.MM.YYYY') {
  const value = moment(date);
  if (!value.isValid()) {
    return 'ERROR';
  }

  return value.utc().format(formating);
}

export function formatDateTime(date: string, formating = 'DD.MM.YYYY HH:mm') {
  const value = moment(date, 'YYYY-MM-DD HH:mm:ssZ');
  if (!value.isValid()) {
    return 'ERROR';
  }

  return value.format(formating);
}
